import React, { useContext, useMemo, useState } from 'react';
import ModuleContext from 'CMFW/context/ModuleContext';
import { Button } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import TranslationsPatternChangeModal from 'modules/Translations/components/TranslationsPatternChangeModal';

type RowData = {
  id: number;
  pattern: string;
  count: number;
  items?: Array<{ translation_id: number; course_id: number; panel_id?: number }>;
};

// Renderer props from ag-Grid
type RendererProps = {
  value: any;
  data: RowData;
};

const MsuChangeRenderer: React.FC<RendererProps> = (props) => {
  const itemsModel: any = useContext(ModuleContext);
  const row = props.data;
  const [modalOpen, setModalOpen] = useState(false);

  const patterns = useMemo<string[]>(() => {
    const arr: any[] = Array.isArray(itemsModel?.gridData) ? itemsModel.gridData : [];
    const unique = Array.from(new Set<string>(arr.map((r: any) => String(r.pattern || ''))));
    return unique as string[];
  }, [itemsModel?.gridData]);

  const translationIds = useMemo(() => {
    return Array.isArray(row?.items) ? row.items.map((i) => i.translation_id) : [];
  }, [row]);

  const dialectId = itemsModel?.dialectId || 0;

  const handleOpen = (e?: React.MouseEvent) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    setModalOpen(true);
  };
  const handleClose = () => setModalOpen(false);

  const changed = !!(row as any)?.__changed;

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        onClick={(e) => handleOpen(e)}
        onMouseDown={(e) => {
          e.stopPropagation();
        }}
        onMouseUp={(e) => {
          e.stopPropagation();
        }}
        disabled={!translationIds.length}
        style={changed ? { borderColor: '#a5d6a7' } : undefined}
      >
        Change
      </Button>
      {changed ? (
        <span title="Updated" style={{ marginLeft: 6, display: 'inline-flex', alignItems: 'center' }}>
          <FontAwesomeIcon icon={faCheck} style={{ color: '#2e7d32' }} />
        </span>
      ) : null}
      <TranslationsPatternChangeModal
        open={modalOpen}
        onClose={handleClose}
        dialectId={dialectId}
        row={row}
        patterns={patterns}
        onSuccess={(ids, editedPattern) => {
          itemsModel.applyMemberChange(row.id, editedPattern);
        }}
      />
    </>
  );
};

export default MsuChangeRenderer;
